import { openModal } from '~/utils/mobileApp';

import { CashnoteIcon } from '~/assets/icons';

export function HelpDesk() {
  return (
    <section className="p-20 pt-16">
      <div className="flex items-center justify-between">
        <div className="text-paragraph typo-paragraph300-semibold">
          캐시노트 고객센터
        </div>

        <button
          type="button"
          className="flex h-40 items-center rounded-12 !bg-[#e8f1ff] px-12 text-blue-700 typo-paragraph100-semibold"
          onClick={() => {
            openModal({
              externalBrowser: true,
              url: 'https://cashnote.zendesk.com/hc/ko/requests/new',
            });
          }}
        >
          <CashnoteIcon />
          문의하기
        </button>
      </div>
      <p className="mt-20 whitespace-pre-line text-description typo-caption100-regular">
        전화문의 1522-9342 <br />
        평일 오전 09:00 ~ 오후 06:00 <br />
        (점심시간 12:00 - 01:00 / 주말 및 공휴일 휴무)
      </p>
    </section>
  );
}
